<!-- Desktop Sidebar -->
<div class="sidebar-container" [class.collapsed]="isCollapsed" [class.mobile]="isMobile">
  <!-- Sidebar Header -->
  <div class="sidebar-header">
    <div class="logo-container" *ngIf="!isCollapsed">
      <img src="assets/main/images/stem/logo-blue.png" alt="STEM Connect" class="logo" />
    </div>
    <div class="logo-container collapsed" *ngIf="isCollapsed">
      <img src="assets/main/images/stem/logo-white.png" alt="STEM Connect" class="logo-small" />
    </div>
    <button
      class="toggle-btn"
      (click)="onToggleSidebar()"
      [attr.aria-label]="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
    >
      <i class="pi" [class.pi-angle-left]="!isCollapsed" [class.pi-angle-right]="isCollapsed"></i>
    </button>
  </div>

  <!-- User Info Section -->
  <div class="user-section" *ngIf="userService.currentUser$ | async as currentUser">
    <div class="user-info" [class.collapsed]="isCollapsed">
      <div class="user-avatar">
        <i class="pi pi-user"></i>
      </div>
      <div class="user-details" *ngIf="!isCollapsed">
        <div class="user-name">{{ currentUser.first_name }} {{ currentUser.last_name }}</div>
        <div class="user-role">{{ currentUser.role?.label || currentUser.role?.description || '' }}</div>
      </div>
    </div>

    <!-- Tenant Selector -->
    <div class="tenant-selector" *ngIf="(currentUser.tenants || []).length > 1">
      <button
        class="tenant-btn"
        [class.collapsed]="isCollapsed"
        (click)="menu.toggle($event)"
        pRipple
        type="button"
      >
        <i class="pi pi-building"></i>
        <span *ngIf="!isCollapsed" class="tenant-name">
          {{ getCurrentTenantName(currentUser.tenant_id, currentUser.tenants || []) }}
        </span>
        <i class="pi pi-chevron-down" *ngIf="!isCollapsed"></i>
      </button>
      <p-menu #menu [popup]="true" [model]="(menuItems$ | async) || []" appendTo="body"></p-menu>
    </div>

    <!-- Navigation Menu -->
    <nav class="sidebar-nav">
      <ul class="nav-list">
        <ng-container *ngFor="let menuItem of menuItems">
          <li class="nav-item" *appHasPermission="menuItem.requiredPermission">
            <!-- Menu item with submenu -->
            <div *ngIf="menuItem.items && menuItem.items.length > 0" class="nav-item-with-submenu">
              <a
                class="nav-link"
                [class.collapsed]="isCollapsed"
                [routerLink]="menuItem.routerLink"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: false }"
                pRipple
              >
                <i class="pi" [class]="menuItem.icon"></i>
                <span class="nav-label" *ngIf="!isCollapsed">{{ menuItem.label }}</span>
                <i class="pi pi-chevron-down submenu-arrow" *ngIf="!isCollapsed"></i>
                <div class="tooltip" *ngIf="isCollapsed">{{ menuItem.label }}</div>
              </a>

              <!-- Submenu items -->
              <ul class="submenu" *ngIf="!isCollapsed">
                <li class="submenu-item" *ngFor="let subItem of menuItem.items">
                  <a
                    class="submenu-link"
                    [routerLink]="subItem.routerLink"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: false }"
                    pRipple
                  >
                    <i class="pi" [class]="subItem.icon"></i>
                    <span class="submenu-label">{{ subItem.label }}</span>
                  </a>
                </li>
              </ul>
            </div>

            <!-- Regular menu item without submenu -->
            <a
              *ngIf="!menuItem.items || menuItem.items.length === 0"
              class="nav-link"
              [class.collapsed]="isCollapsed"
              [routerLink]="menuItem.routerLink"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }"
              pRipple
            >
              <i class="pi" [class]="menuItem.icon"></i>
              <span class="nav-label" *ngIf="!isCollapsed">{{ menuItem.label }}</span>
              <div class="tooltip" *ngIf="isCollapsed">{{ menuItem.label }}</div>
            </a>
          </li>
        </ng-container>
      </ul>
    </nav>
  </div>

  <!-- Sidebar Footer -->
  <div class="sidebar-footer" [class.collapsed]="isCollapsed">
    <div class="footer-actions">
      <button
        class="action-btn"
        [class.collapsed]="isCollapsed"
        [routerLink]="['/settings']"
        pRipple
        title="Settings"
      >
        <i class="pi pi-cog"></i>
        <span *ngIf="!isCollapsed">Settings</span>
      </button>
      <button
        class="action-btn logout-btn"
        [class.collapsed]="isCollapsed"
        (click)="authenticationService.sessionLogout(); userService.clearCurrentLoggedInUser()"
        pRipple
        title="Sign Out"
      >
        <i class="pi pi-sign-out"></i>
        <span *ngIf="!isCollapsed">Sign Out</span>
      </button>
    </div>
  </div>
</div>

<!-- Mobile Top Bar -->
<div class="mobile-topbar" *ngIf="isMobile && authenticationService.userValue">
  <div class="mobile-header">
    <button class="mobile-menu-btn" (click)="onToggleSidebar()" aria-label="Toggle menu">
      <i class="pi pi-bars"></i>
    </button>

    <div class="mobile-logo">
      <img src="assets/main/images/stem/logo-blue.png" alt="STEM Connect" class="logo" />
    </div>

    <div class="mobile-user" *ngIf="userService.currentUser$ | async as currentUser">
      <div class="user-avatar">
        <i class="pi pi-user"></i>
      </div>
      <div class="user-dropdown">
        <button class="user-btn" (click)="userMenu.toggle($event)" pRipple>
          <span class="user-name">{{ currentUser.first_name }}</span>
          <i class="pi pi-chevron-down"></i>
        </button>
        <p-menu #userMenu [popup]="true" [model]="userMenuItems" appendTo="body"></p-menu>
      </div>
    </div>
  </div>

  <!-- Mobile Navigation Tabs -->
  <div class="mobile-nav-tabs" *ngIf="userService.currentUser$ | async">
    <ng-container *ngFor="let menuItem of getVisibleMenuItems()">
      <a
        class="mobile-tab"
        [routerLink]="menuItem.routerLink"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }"
        *appHasPermission="menuItem.requiredPermission"
        pRipple
      >
        <i class="pi" [class]="menuItem.icon"></i>
        <span class="tab-label">{{ menuItem.label }}</span>
      </a>
    </ng-container>
  </div>
</div>

<!-- Mobile Sidebar Overlay -->
<div class="mobile-overlay" *ngIf="isMobile && !isCollapsed" (click)="onCloseSidebar()"></div>

<!-- Mobile Sidebar -->
<div
  class="mobile-sidebar"
  [class.open]="!isCollapsed"
  *ngIf="isMobile && authenticationService.userValue"
>
  <div class="mobile-sidebar-header">
    <div class="mobile-logo">
      <img src="assets/main/images/stem/logo-white.png" alt="STEM Connect" class="logo" />
    </div>
    <button class="close-btn" (click)="onCloseSidebar()" aria-label="Close menu">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <div class="mobile-sidebar-content" *ngIf="userService.currentUser$ | async as currentUser">
    <!-- User Info -->
    <div class="mobile-user-info">
      <div class="user-avatar">
        <i class="pi pi-user"></i>
      </div>
      <div class="user-details">
        <div class="user-name">{{ currentUser.first_name }} {{ currentUser.last_name }}</div>
        <div class="user-role">{{ currentUser.role?.label || currentUser.role?.description || '' }}</div>
      </div>
    </div>

    <!-- Tenant Selector -->
    <div class="mobile-tenant-selector" *ngIf="(currentUser.tenants || []).length > 1">
      <button class="tenant-btn" (click)="mobileMenu.toggle($event)" pRipple>
        <i class="pi pi-building"></i>
        <span class="tenant-name">
          {{ getCurrentTenantName(currentUser.tenant_id, currentUser.tenants || []) }}
        </span>
        <i class="pi pi-chevron-down"></i>
      </button>
      <p-menu
        #mobileMenu
        [popup]="true"
        [model]="(menuItems$ | async) || []"
        appendTo="body"
      ></p-menu>
    </div>

    <!-- Navigation Menu -->
    <nav class="mobile-nav">
      <ul class="mobile-nav-list">
        <ng-container *ngFor="let menuItem of menuItems">
          <li class="mobile-nav-item" *appHasPermission="menuItem.requiredPermission">
            <a
              class="mobile-nav-link"
              [routerLink]="menuItem.routerLink"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="onCloseSidebar()"
              pRipple
            >
              <i class="pi" [class]="menuItem.icon"></i>
              <span class="nav-label">{{ menuItem.label }}</span>
            </a>
          </li>
        </ng-container>
      </ul>
    </nav>
  </div>

  <!-- Mobile Sidebar Footer -->
  <div class="mobile-sidebar-footer" *ngIf="userService.currentUser$ | async">
    <button
      class="mobile-action-btn"
      [routerLink]="['/settings']"
      (click)="onCloseSidebar()"
      pRipple
    >
      <i class="pi pi-cog"></i>
      <span>Settings</span>
    </button>
    <button
      class="mobile-action-btn logout-btn"
      (click)="authenticationService.sessionLogout(); userService.clearCurrentLoggedInUser()"
      pRipple
    >
      <i class="pi pi-sign-out"></i>
      <span>Sign Out</span>
    </button>
  </div>
</div>
